import { Routes } from '@angular/router';

// Import your guards and components
import { AuthGuard } from './guards/auth/auth.guard';
import { ChildGuard } from './guards/child/child.guard';
import { NonAuthGuard } from './guards/non-auth/non-auth.guard';
import { StatGuard } from './guards/stat/stat.guard';
import { PassChangeReqGuard } from './guards/pass-change-req/pass-change-req.guard';

import { LoginComponent } from './components/content/user-profile/login/page/login.component';
import { ChangePasswordComponent } from './components/content/user-profile/change-password/page/change-password.component';
import { EthnicGroupsComponent } from './components/content/survey/ethnic-groups/page/ethnic-groups.component';
import { FileUploadComponent } from './components/content/survey/file-upload/page/file-upload.component';
import { ImpactQuestionsDetailComponent } from './components/content/survey/impact/impact-questions-detail/impact-questions-detail.component';
import { ReviewComponent } from './components/content/survey/review/page/review.component';
import { StatQuestionDetailComponent } from './components/content/survey/stat-questions/stat-question-detail/stat-question-detail.component';
import { HomeComponent } from './components/content/home/page/home.component';
import { UserProfileComponent } from './components/content/user-profile/page/user-profile.component';
import { RecoverPasswordComponent } from './components/content/user-profile/recover-password/page/recover-password.component';

export const routes: Routes = [
  { path: '', canActivate: [NonAuthGuard], component: LoginComponent },
  { path: 'home', canActivate: [AuthGuard], component: HomeComponent },
  {
    path: 'changepassword',
    canActivate: [AuthGuard],
    component: ChangePasswordComponent,
  },
  {
    path: 'requirepasswordchange',
    canActivate: [PassChangeReqGuard],
    component: ChangePasswordComponent,
  },
  {
    path: 'changepassword/:recoveryToken',
    canActivate: [NonAuthGuard],
    component: ChangePasswordComponent,
  },
  {
    path: 'recoverpassword',
    canActivate: [NonAuthGuard],
    component: RecoverPasswordComponent,
  },
  {
    path: 'userprofile',
    canActivate: [AuthGuard],
    component: UserProfileComponent,
  },
  {
    path: 'current-ethnic-groups',
    canActivate: [AuthGuard],
    component: EthnicGroupsComponent,
  },
  {
    path: 'future-ethnic-groups',
    canActivate: [AuthGuard],
    component: EthnicGroupsComponent,
  },
  {
    path: 'photo-upload',
    canActivate: [AuthGuard],
    component: FileUploadComponent,
  },
  {
    path: 'submit-survey',
    canActivate: [AuthGuard],
    component: ReviewComponent,
  },
  // Wildcard route to catch all invalid URLs and redirect appropriately
  {
    path: '**',
    redirectTo: 'home'
  },
];
